module.exports = __webpack_public_path__ + "static/media/m_nose_widebase.fb260691.png";